import React from "react";
import { connect } from "react-redux";
import HomeBanner from "components/banners/HomeBanner";


const HomeScreen = () => {
  
  return (
    <div className="m-4 flex flex-col h-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">      
      <HomeBanner/>
      <h1 className="font-montserrat text-[40px] md:text-[60px] lg:text-[90px] font-black uppercase leading-none text-white text-center max-w-[300px] lg:max-w-[600px] mx-auto home-drop-shadow mb-4">
        DIGITAL LIVESTOCK PLATFORM
      </h1>
      <div className="mt-8">
        <a className="btn btn-primary w-[200px] text-[24px] text-center font-black home-drop-shadow" href="/auth/home">
            Login
        </a>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({  
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);